import { render, staticRenderFns } from "./classical-admin-evaluation-detail.vue?vue&type=template&id=539075e1"
import script from "./classical-admin-evaluation-detail.vue?vue&type=script&lang=js"
export * from "./classical-admin-evaluation-detail.vue?vue&type=script&lang=js"
import style0 from "./classical-admin-evaluation-detail.vue?vue&type=style&index=0&id=539075e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports